
import { Input } from "@/components/ui/input"
import Translatable from '@/components/translatable_text/Translatable'
import { useEffect, useState } from 'react'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import * as z from "zod"
import api from '@/context/apiRequest';
import { toast } from 'sonner'

import { AxiosError } from 'axios'
import { AppState, useSelector } from '@/store/Store'
import { useMutation, useQueryClient } from "@tanstack/react-query"
import MsgComponent from "@/components/msg_component/MsgComponent"
import ButtonComponent from "@/components/button/ButtonComponent"


const formSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().min(1, 'Email is required').email('Invalid Email'),
  is_admin: z.boolean().optional(),
  password: z.string().min(1, 'Password is required'),
  password_confirmation: z.string().min(1, 'Confirmation password is required')
})
.refine((data) => data.password === data.password_confirmation, {
  path: ['password_confirmation'],
  message: "Passwords does not match"
})



type Props = {
  setOpen: any
}

export default function AddNewUserForm({setOpen}: Props){

  const customizer = useSelector((state: AppState) => state.customizer);

  const [ err, setErr ] = useState<string>()

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      is_admin: false
    },
  })

  const { isSubmitting } = form.formState;

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (values: object) => {
      return api().post(`/api/v1/admin/users`, values );
    }, 
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users']})
    }
  })

  const submitPasswordChange = async (values: z.infer<typeof formSchema>) => {
    
    try {
      
      const res = await mutation.mutateAsync(values)
      console.log(res);
      toast.success('User added successfully')
      setOpen(false);

    } catch (error) {
      if (error instanceof AxiosError) {
        setErr(error.response?.data?.message || error.response?.data.error)
      }
      console.log(error)
    } 
  } 

 useEffect(() => {
    const timer = setTimeout(() => {
      setErr('')
    }, 10000);
  
    return () => {
      clearTimeout(timer);
    };
    
  }, [err])


  return (
    <div dir={customizer.activeDir} className='w-full px-6'>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(submitPasswordChange)}
          className="space-y-2 mt-5"
        >
          <div className='flex flex-col md:flex-row flex-wrap w-full gap-5'>
            <div className="w-full flex flex-col md:flex-row gap-5">
              <div className='w-full '>
                <FormField
                  control={form.control}
                  name="name"
                  render={({ field }) => (
                    <FormItem>
                    <FormLabel>
                      <Translatable>
                        Name
                      </Translatable>
                    </FormLabel>
                      <FormControl>
                        <Input
                          placeholder="Write a name"
                          type='text'
                          {...field}
                          />
                      </FormControl>
                      <FormMessage/> 
                    </FormItem>
                  )}
                />
              </div>
              <div className='w-full'>
                <FormField
                  control={form.control}
                  name="email"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        <Translatable>
                          Email
                        </Translatable>
                      </FormLabel>
                      <FormControl>
                        <Input
                        type="text"
                        autoComplete="on"
                        placeholder="Enter an email"
                        {...field}
                        />
                      </FormControl>
                      <FormMessage/> 
                    </FormItem>
                  )}
                />
              </div>
            </div>
    
            <div className='flex flex-col md:flex-row flex-wrap w-full gap-5'>
              <div className='w-full flex-1'>
                <FormField
                  control={form.control}
                  name="password"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        <Translatable>
                          Password
                        </Translatable>
                        </FormLabel>
                      <FormControl>
                        <Input
                        type='password'
                        autoComplete="new-password"
                        placeholder="**********"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                          form.clearErrors('password');
                        }}
                        />
                      </FormControl>
                      <FormMessage/> 
                    </FormItem>
                  )}
                />
              </div>
              <div className='w-full flex-1'>
                <FormField
                  control={form.control}
                  name="password_confirmation"
                  render={({ field }) => (
                    <FormItem>
                    <FormLabel>
                      <Translatable>
                        Confirm Password
                      </Translatable>
                      </FormLabel>
                      <FormControl>
                        <Input
                          type='password'
                          autoComplete="new-password"
                          placeholder="**********"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                            form.clearErrors('password_confirmation');
                          }}
                          />
                      </FormControl>
                      <FormMessage/> 
                    </FormItem>
                  )}
                />
              </div>
            </div>


            <MsgComponent className='flex items-center justify-center text-rose-700 p-4' message={err}/>
            <ButtonComponent
              title='Submit'
              className='w-full mt-5 bg-purple hover:bg-purple/70'
              isSubmitting={isSubmitting}
              onClick={() => submitPasswordChange}
              variant="default"
            />
          </div>

        </form>
      </Form>
    </div>
  )
}